import { findService, findCategory, findRegion, findGroup } from '@/api/service'

export const initFilterOptions = () => ({
  categoryId: '',
  searchKey: '',
  regionId: '',
  partyId: '',
  groupId: ''
})
export default {
  namespaced: true,
  state () {
    return {
      filterOptions: initFilterOptions(),
      list: [],
      categoryList: [],
      regionList: [],
      groupList: [],
      loading: false,
      categoryLoading: true,
      regionLoading: true,
      groupLoading: true
    }
  },
  mutations: {
    setFilterOptions (state, payload) {
      state.filterOptions = { ...state.filterOptions, ...payload }
    },
    setList (state, payload) {
      state.list = payload
    },
    setCategoryList (state, payload) {
      state.categoryList = payload
    },
    setCategoryLoading (state, payload) {
      state.categoryLoading = payload
    },
    setRegionLoading (state, payload) {
      state.regionLoading = payload
    },
    setGroupLoading (state, payload) {
      state.groupLoading = payload
    },
    setRegionList (state, payload) {
      state.regionList = payload
    },
    setGroupList (state, payload) {
      state.groupList = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    }
  },
  actions: {
    getList ({ commit }) {
      const promise = new Promise((resolve, reject) => {
        if (window.list) {
          resolve(window.list)
        } else {
          commit('setLoading', true)
          findService().then((res) => {
            commit('setLoading', false)
            res.data && res.data.forEach((item) => {
              item.label = item.label ? item.label : ''
              item.party = item.party ? item.party : ''
              item.category = item.category ? item.category : ''
              item.categoryId = item.categoryId ? item.categoryId : ''
              item.groupId = item.groupId ? item.groupId : ''
              item.regionId = item.regionId ? item.regionId : ''
            })
            resolve(res.data || [])
            window.list = res.data || []
          })
        }
      })
      promise.then((res) => {
        commit('setList', res || [])
      })
    },
    getCategoryList ({ commit }) {
      const promise = new Promise((resolve, reject) => {
        if (window.categoryList) {
          resolve(window.categoryList)
        } else {
          commit('setCategoryLoading', true)
          findCategory().then((res) => {
            commit('setCategoryLoading', false)
            res.data.unshift({
              categoryId: '',
              label: '全部',
              name: '全部'
            })
            resolve(res.data)
            window.categoryList = res.data
          })
        }
      })
      promise.then((res) => {
        commit('setCategoryList', res)
      })
    },
    getRegionList ({ commit }) {
      const promise = new Promise((resolve, reject) => {
        if (window.regionList) {
          resolve(window.regionList)
        } else {
          commit('setRegionLoading', true)
          findRegion().then((res) => {
            commit('setRegionLoading', false)
            res.data.unshift({
              regionId: '',
              label: '全部',
              name: '全部'
            })
            resolve(res.data)
            window.regionList = res.data
          })
        }
      })
      promise.then((res) => {
        commit('setRegionList', res)
      })
    },
    getGroupList ({ commit }) {
      const promise = new Promise((resolve, reject) => {
        if (window.groupList) {
          resolve(window.groupList)
        } else {
          commit('setGroupLoading', true)
          findGroup().then((res) => {
            commit('setGroupLoading', false)
            res.data.unshift({
              groupId: '',
              label: '全部',
              name: '全部'
            })
            resolve(res.data)
            window.groupList = res.data
          })
        }
      })
      promise.then((res) => {
        commit('setGroupList', res)
      })
    }
  },
  getters: {
    filterList (state) {
      const list = state.list
      let filterList = list.sort((a, b) => {
        if (a.idx && b.idx) return a.idx.localeCompare(b.idx)
        return null
      })

      // 按照关键字查询
      const { searchKey, categoryId, regionId, groupId } = state.filterOptions
      filterList = filterList.filter((item) => {
        if (
          (item.label.includes(searchKey) ||
            item.party.includes(searchKey) ||
            item.category.includes(searchKey)) &&
          item.categoryId.includes(categoryId)
        ) {
          if (
            groupId === '' ||
            item.groups.find((item) => item.groupId === groupId)
          ) {
            if (regionId === '' || item.regions.find((item) => item.regionId === regionId)) {
              return item
            }
          }
        }
        return null
      })
      return filterList
    }
  }
}
